angular.module('account.edit-article-live', [
  'common.header',
  'common.footer',
  'config',
  'directives.contenteditable',
  'account.settings.social',
  'security.service',
  'security.authorization',
  'services.accountResource',
  'services.utility',
  'services.formErrors',
  'ui.bootstrap',
  'directives.serverError',
  'ngTagsInput',
  'ngFileUpload',
  'toggle-switch',
  'angular-growl',
  'ckeditor',
  'resources.User',
  'resources.Tag',
  'resources.Category',
  'resources.Article',
  'filters.rawHtml',
  'ckeditorPlaceholder',
  'services.localizedMessages'
])

  .config(["$stateProvider", function ($stateProvider) {
    $stateProvider
      .state('account.edit-article-live', {
        url: '/edit-article-live/:id',
        title: 'Edit Article live',
        views: {
          'main@': {
            template: require('./edit-article-live.tpl.html'),
            controller: 'EditArticleliveCtrl',
            resolve: {
              locations: ["adminResource", function (adminResource) {
                return adminResource.searchTags({type: 'location'})
              }],
              playersAndTeams: ["adminResource", function (adminResource) {
                return adminResource.searchTags({type1: 'profile', type2: 'organization'})
              }],
            }
          }
        }
      });
  }])

  .controller('EditArticleliveCtrl',
    ["$scope", "$location", "$log", "$interval", "$stateParams", "security", "utility", "growl", "user", "SOCIAL", "STATUSES", "Upload", "APP_IMG_URLS", "formErrors", "dateFilter", "Article", "Category", "Tag", "socket", "$window", "locations", "playersAndTeams", "localizedMessages", "adminResource", function ($scope,
              $location,
              $log,
              $interval,
              $stateParams,
              security,
              utility,
              growl,
              user,
              SOCIAL,
              STATUSES,
              Upload,
              APP_IMG_URLS,
              formErrors,
              dateFilter,
              Article,
              Category,
              Tag,
              socket,
              $window,
              locations,
              playersAndTeams,
              localizedMessages,
              adminResource) {
      $scope.localizedMessages = localizedMessages;
      STATUSES = STATUSES.map( (status) => Object.assign(status, { value: localizedMessages.get(status.value) }) );
      $scope.pinComment = false;
      $scope.dataLoaded = false;
      var urlGenerated = false;
      var timer = null;
      var slugify = require('../../utils/slugify');

      $scope.editPermit = false;
      $scope.imgUrl = APP_IMG_URLS.base;

      var toFormatArticleDate = require('../rgr-utils').toFormatArticleDate;
      var prepareBeforeEmitArticleChanged = require('../rgr-utils').prepareBeforeEmitArticleChanged;
      var prepareForEditArticle = require('../rgr-utils').prepareForEditArticle;

      var publishDatePrev = moment();
      var startDatePrev;
      var endDatePrev;

      var init = function (article, categories) {

        if (article.status) {
          if ([1, 3, 17, 18].indexOf(article.status) >= 0) {
            publishDatePrev = moment(article.publish_date);
          }
        }

        startDatePrev = moment(article.startDate);
        endDatePrev = moment(article.endDate);

        // console.log( '>>>', article.startDate );

        $scope.categories = categories;
        $scope.stadiumsList = !!locations ? locations.data.map(function (p) {
          return {_id: p._id, name: p.name}
        }) : [];
        $scope.playersAndTeamsList = !!playersAndTeams ? playersAndTeams.data.map(function (p) {
          return {
            _id: p._id,
            name: p.name,
            type: p.role.role_type
          }
        }) : [];
        $scope.profilesList = $scope.playersAndTeamsList.length ? $scope.playersAndTeamsList.filter(function (e) {
          return e.type === 'profile';
        }) : [];
        $scope.statuses = _.filter(STATUSES, function (status) {
          return ~user.permissions.statuses.indexOf(status.id);
        });
        if (user.permissions.statuses[0] === '*') {
          $scope.statuses = STATUSES;
        }

        $scope.notas = {
          titulo: '',
          nota: '',
          id: 0
        };
        $scope.isAdmin = false;
        // console.log("user.permissions.is_admin------->>>>>>>" + user.permissions.is_admin);
        if (user.permissions.is_admin) {
          $scope.isAdmin = true;
          // console.log("$scope.isAdmin------->>>>>>>" + $scope.isAdmin);
        }

        // console.log( '>>>', startDatePrev.format('LLL'), startDatePrev.local().format('YYYY-MM-DD HH:mm') );

        $scope.data = {
          _id: article._id,
          article_id: article.article_id,
          title: _.unescape(article.title),
          sefriendly: article.sefriendly,
          status: _.find(STATUSES, {id: '' + article.status}),
          orderNumber: article.orderNumber,
          image: article.image,
          video: article.video,
          image_caption: _.unescape(article.image_caption),
          body: _.unescape(article.body),
          isbodylive: article.isbodylive ? article.isbodylive : false,
          bodylive: article.bodylive ? article.bodylive : [],
          abstract: _.unescape(article.abstract),

          equipo_local:
            article.equipo_local_new ? _.find($scope.playersAndTeamsList, {_id: article.equipo_local_new._id}) :
              article.equipo_local ? _.find($scope.playersAndTeamsList, {_id: article.equipo_local}) : undefined,

          equipo_visitante:
            article.equipo_visitante_new ? _.find($scope.playersAndTeamsList, {_id: article.equipo_visitante_new._id}) :
              article.equipo_visitante ? _.find($scope.playersAndTeamsList, {_id: article.equipo_visitante}) : undefined,

          goals: article.goals,
          goles_local: article.goles_local,
          goles_visitante: article.goles_visitante,

          referee: article.referee_new ? _.find($scope.profilesList, {_id: article.referee_new._id}) :
            !!article.referee ? _.find($scope.profilesList, {_id: article.referee}) : undefined,

          incidents: article.incidents,
          category: article.category ? _.find(categories, {id: article.category.id}) : '',
          tags: [],
          author: article.author,
          last_edited_by: article.last_edited_by,

          startDate: toFormatArticleDate(startDatePrev),
          endDate: toFormatArticleDate(endDatePrev),

          published_by: article.published_by,
          publish_date: toFormatArticleDate(publishDatePrev),

          team1: article.team1,
          team2: article.team2,
          team1players: angular.isArray(article.team1players) ? article.team1players.map(function (e) {
            return Object.assign(e, {text: e.name});
          }) : [],
          team2players: angular.isArray(article.team2players) ? article.team2players.map(function (e) {
            return Object.assign(e, {text: e.name});
          }) : [],
          created_at: article.created_at,

          stadium: article.stadium_new ? _.find($scope.stadiumsList, {_id: article.stadium_new._id}) :
            !!article.stadium ? _.find($scope.stadiumsList, {_id: article.stadium}) : undefined,
        };
        $scope.changePT1(article.equipo_local);
        $scope.changePT2(article.equipo_visitante);

        var listenerFunction = null;

        //send user name of person who start editing and  id of edited topic
        socket.emit('connectDocs', {
          userName: user.account.name.full,
          artId: article.article_id,
          userId: user._id,
          docs: $scope.data
        });

        var internalChange = false;
        var listenData = false;
        socket.on('startEditing', function (data) {
          $scope.editPermit = true;
          $scope.editing = "Editing by: " + user.account.name.full

          if (data) {
            $scope.data = prepareForEditArticle(data.data);
          }

          listenerFunction = $scope.$watchCollection("data", _.debounce(function (newValue, oldValue) {
            if (!_.isEqual(newValue, oldValue) && !internalChange) {
              socket.emit('articleChanged', {
                artId: article.article_id,
                data: prepareBeforeEmitArticleChanged(newValue)
              });
            }
            internalChange = false
          }, 1000));
          listenData = true
        })

        socket.on('startWatching', function (articleRoom) {
          $scope.data = articleRoom.docs;
          var user = _.find(articleRoom.users, function (user) {
            return user.userId === articleRoom.editing
          })
          $scope.editing = "editing by: " + user.name;
        })

        socket.on('newcomer', function (watchers) {
          $scope.watching = watchers.reduce(function (prev, obj) {
            return prev + obj.name + ', '
          }, "watching by: ")
        })

        //send user name of person who ends editing and  id of edited topic
        $scope.$on('$locationChangeStart', function (event) {
          if ($scope.editPermit) {
            socket.emit('endEdit');
            socket.off('applyChanges');
          }
        });

        var windowElement = angular.element($window);
        windowElement.on('beforeunload', function (event) {
          // do whatever you want in here before the page unloads.
          if ($scope.editPermit) {
            socket.emit('endEdit');
            socket.off('applyChanges');
          }
          // the following line of code will prevent reload or navigating away.
          event.preventDefault();
        });

        //recieving changes from other editors
        socket.on('applyChanges', function (data) {
          if (data.editing === user._id) {
            $scope.editPermit = true
            if (!listenerFunction) {
              listenerFunction = $scope.$watchCollection("data", _.debounce(function (newValue, oldValue) {
                if (!_.isEqual(newValue, oldValue) && !internalChange) {
                  socket.emit('articleChanged', {
                    artId: article.article_id,
                    data: prepareBeforeEmitArticleChanged(newValue)
                  });
                }
                internalChange = false
              }, 1000));
            }
          } else {
            $scope.editPermit = false;
            if (listenerFunction) {
              listenerFunction();
              listenerFunction = null;
            }
          }
          const users = data.users
          const editor = _.find(users, function (us) {
            return us.userId === data.editing
          })
          const watchers = users.filter(function (us) {
            return us.userId !== data.editing
          })
          $scope.editing = "editing by: " + editor.name
          $scope.watching = watchers.reduce(function (prev, obj) {
            return prev + obj.name + ', '
          }, "watching by: ");


          if (!_.isEqual($scope.data, data.docs)) {
            $scope.data = prepareForEditArticle(data.docs);
            internalChange = true
          }
        });

        $scope.switch = function () {
          socket.emit('changeEditPermit', {
            artId: article.article_id,
            userId: user._id,
          })
        };

        if (article.tags) {
          $scope.data.tags = article.tags.map(function (tag) {
            return {
              _id: tag._id,
              text: tag.name,
              sefriendly: slugify(tag.name)
            }
          });
        }

        if ($scope.data.status == undefined) {
          $scope.data.status = {
            id: '0',
            value: localizedMessages.get('pending')
          }
        }
        $scope.dataLoaded = true;
      };

      $scope.uploading = false;
      $scope.isSaving = false;
      $scope.autosaveTimer = 180;
      $scope.accordion = {
        score: true,
        publishing_date: true,
        url: true,
        image: true,
        published_by: false
      };

      var startTimer = function () {
        return $interval(function () {
          if ($scope.autosaveTimer <= 0) {
            $scope.save();
          }
          $scope.autosaveTimer -= 1;
        }, 1000);
      };

      var resetTimer = function () {
        $scope.autosaveTimer = 180;
        $interval.cancel(timer);
      };

      $scope.autosaveChanged = function () {
        if ($scope.autosave) {
          timer = startTimer();
        } else {
          resetTimer();
        }
      };

      $scope.canChangeAuthor = function () {
        return user.permissions.is_editor && $scope.canChangeCategory();
      };

      $scope.canChangeStatus = function () {
        if (user.permissions.is_admin) return true;
        return true;
        //return ~user.permissions.statuses.indexOf(article.status + '');

      };

      $scope.canChangeCategory = function () {
        if (user.permissions.is_admin) return true;
        return true;
        //return ~user.permissions.categories.indexOf(article.category.id);
      };

      $scope.canChangeFormat = function () {
        return true;
      };

      $scope.titleChanged = function () {
        $scope.data.title = $scope.data.title.replace(/<.+?>/g, "").replace(/  /g, " ")
        if ($scope.data.sefriendly) {
          return;
        }
        $scope.data.sefriendly = slugify($scope.data.title.replace(/<.+?>/g, "").replace(/  /g, " "));
      };

      $scope.saveBtnText = "Save";
      $scope.switchBtnText = "Switch";

      $scope.save = function () {
        resetTimer();
        $scope.autosaveChanged();
        $scope.data.sefriendly = slugify($scope.data.sefriendly);
        if (!$scope.data.title) {
          growl.error('Title is required');
          return;
        }
        if (!$scope.data.category) {
          growl.error('Category is required');
          return;
        }
        if (!$scope.data.body && !$scope.data.isbodylive) {
          growl.error('Body is required');
          return;
        }

        if ($scope.data.bodylive.length === 0 && $scope.data.isbodylive) {
          growl.error('Body is required');
          return;
        }

        $scope.isSaving = true;

        var data = angular.copy($scope.data);
        data.edition = data.category.path.split("/")[1];
        data.show_inarticle = 21;
        data.status = parseInt(data.status.id, null);
        // data.categories = data.category.path.split('/').filter(Boolean).map(function(item) {return {sefriendly: item};}).reverse();
        // delete data['category'];
        data.category = {
          id: data.category.id,
          name: data.category.name,
          sefriendly: data.category.sefriendly,
          parent: data.category.parent,
          parent_id: data.category.parent_id
        }

        data.tags = data.tags || [];
        data.tags = data.tags.map(function (tag) {
          return {
            name: tag.text,
            sefriendly: slugify(tag.text)
          };
        });


        data.publish_date = (data.publish_date ? moment(data.publish_date) : publishDatePrev).toISOString();
        data.startDate = (data.startDate ? moment(data.startDate) : startDatePrev).toISOString();
        data.endDate = (data.endDate ? moment(data.endDate) : endDatePrev).toISOString();

        if (!$scope.canChangeAuthor()) {
          data.last_edited_by = {
            name: user.account.name.full,
            username: user.username
          };
        }

        if (~[1, 17, 19, 20, 90].indexOf(data.status)) {
          data.published_by = {
            name: user.account.name.full,
            username: user.username
          }
        }

        var catArray = data.category.parent == "/" ? [] : data.category.parent.substring(1).split('/');
        var pDate = new Date(data.created_at);
        var pMonth = pDate.getUTCMonth() + 1;
        var dateSeg = '/' + pDate.getUTCFullYear()
          + '/' + ('0' + pMonth).slice(-2)
          + '/' + ('0' + pDate.getUTCDate()).slice(-2)
          + '/';
        data.url_segment = dateSeg;
        if (catArray.length == 0) {
          data.url_segment = '/' + data.category.sefriendly + dateSeg;
        } else if (catArray.length == 1) {
          data.url_segment = '/' + catArray[0] + '/' + data.category.sefriendly + dateSeg;
        } else if (catArray.length > 1) {
          data.url_segment = '/' + catArray[0] + '/' + catArray[1] + dateSeg + data.category.sefriendly + '/';
        }

        // console.log("$startDate------->>>>>>>" + data.startDate);
        //console.log( '>>>', data );

        Article.update(data, function (result) {
          setTimeout(function () {
            //growl.info('Changes saved!');
            $scope.data.last_edited_by = data.last_edited_by;
          }, 1000);
        }, formErrors.growlErrors).$promise.then(function () {
          $scope.saveBtnText = "Saved!";
          $scope.isSaving = false;
          // setTimeout(function () {
          //   $scope.saveBtnText = "Saved!";
          // }, 500);
        });
      };

      $scope.addComment = function () {
        var text = angular.copy($scope.notas.nota);

        if( CKEDITOR.instances.editor ) {
          text = CKEDITOR.instances.editor.getData();
          CKEDITOR.instances.editor.focusManager.blur( true );
        }

        if (text === '') {
          alert('please enter a comment');
          return;
        }
        text = text.replace('<p>', '');
        text = text.replace('</p>', '');
        var now = new Date();
        var fecha = new Date().toISOString();
        //var fecha = new Date(now.getTime() + now.getTimezoneOffset() * 60000).toISOString();
        if (!$scope.data.isbodylive) {
          var idiv = $scope.notas.id + 1;
          var div1 = "<div id=post'" + idiv + "' itemprop='liveBlogUpdate' itemscope itemtype='http://schema.org/BlogPosting'>";
          var headline = "<h2 itemprop='headline'>";
          var tiempo = "<a href=" + "http://188.165.235.121:7790/account/edit-article-live/" + $scope.data.article_id + "#post" + idiv + "' itemprop='url'><time datetime='" + fecha + "' data-relativeformat='med' itemprop='datePublished' title='" + fecha + "'GMT'>" + fecha + "</time></a>";
          var comentario = "";
          var keyWord = "<img ";
          var position = text.indexOf(keyWord);
          if (position !== -1) {
            var itemprop = "itemprop='image'";
            var imagen2 = text.replace('<img', '<img ' + itemprop);
            comentario = imagen2;
            // console.log("imagen------->" + comentario);
          } else {
            if (text != "") {
              var letra = "<p itemprop='articleBody'>" + text + "</p>";
              comentario = letra;
            } else {
              return;
            }
          }
          // console.log("comentario------->" + comentario);.on
          var titulo = $scope.notas.titulo;
          var tituloTotal = "";
          if (titulo != "") {
            tituloTotal = headline + titulo + "</h2>";
            // console.log("tituloTotal----->" + tituloTotal);
          }
          var bocomentario = div1 + tituloTotal + tiempo + comentario + "</div>";
          //console.log("bocomentario----->"+bocomentario);
          $scope.data.body = bocomentario + $scope.data.body;
        } else {
          var titulo = $scope.notas.titulo.replace(/<[^>]*>|&nbsp;/g, "");
          var idiv = $scope.data.bodylive.length + 1;
          var newBodyLive = $scope.data.bodylive;
          newBodyLive.splice($scope.pinComment ? 1 : 0, 0, {
            postId: idiv,
            title: titulo,
            date: fecha,
            description: text
          });
          $scope.data.bodylive = newBodyLive;
        }
        $scope.notas = {
          titulo: '',
          nota: '',
          id: idiv
        };
        $scope.save();
      };

      $scope.setPinComment = function (body, index) {
        if (index > 0) {
          $scope.pinComment = true;
          var i0 = $scope.data.bodylive[0];
          $scope.data.bodylive[0] = $scope.data.bodylive[index];
          $scope.data.bodylive[index] = i0;
        } else {
          $scope.pinComment = !$scope.pinComment;
        }
        // console.log(index, $scope.data.bodylive);
        $scope.save();
      };

      $scope.editBodyLive = function (body, index) {
        $scope.data.bodylive[index] = body;
        $scope.save();
      };

      $scope.notify = function () {
        var data = angular.copy($scope.data);
        data.edition = data.category.path.split("/")[1];
        data.show_inarticle = 21;
        data.status = parseInt(data.status.id, null);
        data.category = {
          id: data.category.id,
          name: data.category.name,
          sefriendly: data.category.sefriendly,
          parent: data.category.parent,
          parent_id: data.category.parent_id
        }

        data.tags = data.tags || [];
        data.tags = data.tags.map(function (tag) {
          return {
            name: tag.text,
            sefriendly: slugify(tag.text)
          };
        });

        if (!$scope.canChangeAuthor()) {
          data.last_edited_by = {
            name: user.account.name.full,
            username: user.username
          };
        }

        if (~[1, 17, 19, 20, 90].indexOf(data.status)) {
          data.notify = 1;
          //console.log($scope.data.title);
          Article.update(data, function (result) {
            setTimeout(function () {
              //growl.info('Changes saved!');
              $scope.data.last_edited_by = data.last_edited_by;
              // $location.path('/edit-article/' + result.data._id);
            }, 1000);
          }, formErrors.growlErrors).$promise.then(function () {
            $scope.saveBtnText = "Saved!";
            $scope.isSaving = false;
            setTimeout(function () {
              $scope.saveBtnText = "Saved!";
            }, 500);
          });
        }

      };

      $scope.$on('$locationChangeStart', function (event, next, current) {
        if (!$scope.isSaving) {
          var answer = confirm("Are you sure you want to navigate away from this page");
          if (!answer) {
            event.preventDefault();
          }
        }
      });

      $scope.$watch('file', function (file) {
        if (!file) return;
        $scope.upload(file);
      });

      // upload on file select or drop
      $scope.upload = function (file) {
        $scope.uploading = true;
        $scope.thumbnail = file;
        Upload.upload({
          url: '/api/articles/upload',
          data: {file: file}
        }).then(function (resp) {
          $scope.uploading = false;
          $scope.thumbnail = APP_IMG_URLS.base + resp.data.filename;
          $scope.data.image = resp.data.filename;
        }, function (resp) {
          $scope.uploading = false;
          $scope.thumbnail = null;
          console.log('Error status: ' + resp.status);
        }, function (evt) {
          var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
          console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
        });
      };

      $scope.loadTags = function (query) {
        return Tag.search({q: query}).$promise.then(function (tags) {
          if (!tags) return [];
          return tags.map(function (tag) {
            return {
              _id: tag._id,
              text: tag.nametag,
              name: tag.nametag,
              sefriendly: slugify(tag.name)
            }
          })
        });
      };

      $scope.delete = function (article) {
        if ($scope.isAdmin) {
          if (!confirm('Are you sure you want to delete this article?')) {
            return;
          }
          Article.delete({id: article._id}, function (result) {
            setTimeout(function () {
              growl.info('Article removed!');
              $location.path('/account/my-articles');
            }, 1000);
          }, formErrors.growlErrors);
        }
      }

      async.parallel({
        article: function (cb) {
          Article.query({id: $stateParams.id}).$promise.then(function (result) {
            return cb(null, result);
          })
        },
        categories: function (cb) {
          var options = [];
          var generateCategoryOptions = function (items, container) {
            items.forEach(function (item) {

              if (!item.path) {
                return;
              }
              var depth = item.path.split('/').filter(Boolean).length;
              var indent = (new Array(5)).join(String.fromCharCode(160));
              container.push({
                id: item.id,
                path: item.path,
                sefriendly: item.sefriendly,
                parent: item.parent,
                parent_id: item.parent_id,
                name: item.name,
                _name: (new Array(depth)).join(indent) + item.name
              });
              if (item.children) {
                generateCategoryOptions(item.children, container);
              }
            });
            return container;
          };
          Category.getPermittedTree().$promise.then(function (data) {
            generateCategoryOptions(data, options);
            cb(null, options);
          })
        }
      }, function (err, results) {
        if (err) return console.log(err);
        if (results.article.error) {
          $location.path('/unauthorized');
        } else {
          if (results.article.show_inarticle == 21 || results.article.show_inarticle == 22) {
            init(results.article, results.categories);
          } else {
            $scope.isSaving = true;
            $location.path('/account/edit-article/' + results.article.article_id);
          }
        }
      });

      $scope.changePT1 = function (pt1) {
        var playerOrTeam = $scope.playersAndTeamsList.filter(function (e) {
          return e._id === pt1;
        });
        if (playerOrTeam.length) {
          $scope.data.equipo_local_name = playerOrTeam[0].name;
        }
      }

      $scope.changePT2 = function (pt2) {
        var playerOrTeam = $scope.playersAndTeamsList.filter(function (e) {
          return e._id === pt2;
        });
        if (playerOrTeam.length) {
          $scope.data.equipo_visitante_name = playerOrTeam[0].name;
        }
      }

      $scope.loadProfiles = function (query) {
        return adminResource.searchTags({type: 'profile', name: query}).then(function (profiles) {
          if (!profiles) return [];
          var searchName = query.toLowerCase();
          return profiles.data.filter(function (p) {
            var name = p.name.toLowerCase();
            return name.indexOf(searchName) > -1;
          }).map(function (p) {
            return {
              _id: p._id,
              name: p.name,
            }
          })
        });
      };
    }]);



// WEBPACK FOOTER //
// ./client/src/app/account/edit-article-live/edit-article-live.js